import { IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import Image_nl from "@/assets/nl/explain-your-mission@2x.png";
import { useMyData } from "@/lib/query/functions/user/data";
import { cx } from "@/lib/style/cva.config";
import { Button } from "../Global/Button";
import { Content } from "../Global/Content";

export function YourMissionOnboardingContent(
	props: React.ComponentPropsWithoutRef<typeof Content>,
) {
	const { t, i18n } = useTranslation();
	const [, { mutation }] = useMyData();

	return (
		<Content {...props} className={cx("part-scroll:justify-center", props.className)}>
			<div className="flex h-full items-center sm:h-auto">
				<img
					src={{ nl: Image_nl }[i18n.language]}
					className="mx-auto sm:max-h-[60vmin] sm:max-w-[60vmin]"
					alt={t("your-mission.onboarding.image-alt")}
				/>
			</div>

			<div className="mt-auto flex flex-col items-center gap-8 sm:mt-0">
				<div className="flex flex-col items-center gap-1">
					<IonText className="text-brown-700 text-center text-3xl font-bold">
						{t("your-mission.onboarding.title")}
					</IonText>
					<IonText className="text-brown-600 text-center text-lg text-pretty">
						{t("your-mission.onboarding.message")}
					</IonText>
				</div>

				<Button
					data-attr="page.app.your-mission.onboarding.action"
					expand="block"
					className="w-full sm:max-w-56"
					onClick={() => {
						mutation.mutate((draft) => {
							draft.modal.yourMissionExplainer.seen = true;
						});
					}}
				>
					{t("your-mission.onboarding.action")}
				</Button>
			</div>
		</Content>
	);
}
